"use strict";
var Observable_1 = require("../../Observable");
var pluck_1 = require("../../operator/pluck");
Observable_1.Observable.prototype.pluck = pluck_1.pluck;
//# sourceMappingURL=pluck.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/pluck.js
 ** module id = 359
 ** module chunks = 1
 **/